



















































import { apiSaleAfterWriteOffOrderSaleAfterDetail } from '@/api'
import { computed } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent, useApi, useQuery } from '@/hooks'
import { Track } from '@/utils'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '退款详情',
        }))
      }

      query = useQuery<{
        refundId: string
      }>()

      apiData = useApi(() =>
        apiSaleAfterWriteOffOrderSaleAfterDetail({
          id: this.query.refundId,
        }),
      )

      pageData = computed(() => this.apiData.data)

      handleProgressClick = (e?: { target?: HTMLSpanElement }) => {
        if (e?.target?.dataset?.contact) {
          dcb.makePhoneCall({
            phoneNumber: e.target.innerText.trim(),
          })
        }
      }
    },
)
